// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"6d5870f282dd4489","6831":"ef9bc0b95974009d","8503":"b0e579e9fd9e3924","9683":"565c3fbe7bb69625"}[chunkId] + ".js";
};